import { render } from "./SubscriptionItem.vue?vue&type=template&id=42c969e1"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__